// extracted by mini-css-extract-plugin
export default {"contents":"lE-z","sectionHeading":"mE-z"};